import { EMPTY_OBJECT } from '../../../constants/common'
import { SearchItem } from '../../Search'

import { POST_SEARCH_ITEM_ICON } from './PostSearchItem.constants'

import * as styles from './PostSearchItem.module.css'

function PostSearchItem({ className = styles.PostSearchItem, value }) {
  const { title } = value.item ?? EMPTY_OBJECT

  return (
    <SearchItem
      className={className}
      icon={POST_SEARCH_ITEM_ICON}
      title={title}
    />
  )
}

export default PostSearchItem
